
<template>

  <div v-if="$common.qr.status==QR_STATUS_VALID&&$common.qr.type==TYPE_SOLUTION">
    <ComponentContainer :components="components" :pg="true" :control="null"/>
  </div>

  <div v-if="$common.qr.status==QR_STATUS_VALID&&$common.qr.type!=TYPE_SOLUTION">
    <QuickAlbum :quick_album="qrjson" v-if="$common.qr.type==TYPE_IMAGE"/>
    <QuickText :quick_text="qrjson" v-if="$common.qr.type==TYPE_TXT"/>
    <QuickUrl :quick_url="qrjson" v-if="$common.qr.type==TYPE_URL"/>
    <QuickFile :quick_files="qrjson" v-if="$common.qr.type==TYPE_FILE"/>
    <QuickAudio :quick_audios="qrjson" v-if="$common.qr.type==TYPE_MP3"/>
    <QuickVideo :quick_videos="qrjson" v-if="$common.qr.type==TYPE_VIDEO"/>
  </div>
  
  <div v-if="$common.qr.status==QR_STATUS_LOADING" class="result-container">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div style="color:#3b82f6;margin-top:20px">{{ $t("message.loading_qr") }}</div>   
  </div>

  <div v-if="$common.qr.status==QR_STATUS_INVALID" class="result-container">
      <img src="@/assets/icons/invalid.png" style="max-width:20%"/>
      <div class="error">{{ $t("message.invalid_qr") }}</div>
  </div>
  
  <div v-if="$common.qr.status==QR_STATUS_NOT_STARTED" class="result-container">
      <img src="@/assets/icons/alarm.png" style="max-width:20%"/>
      <div class="error">{{ $t("message.campaign_not_start") }}</div>
  </div>
  
  <div v-if="$common.qr.status==QR_STATUS_ENDED" class="result-container">
      <img src="@/assets/icons/alarm.png" style="max-width:20%"/>
      <div class="error">{{ $t("message.campaign_end") }}</div>
  </div>

  <div v-if="$common.qr.status==QR_STATUS_PLAN_EXPIRED" class="result-container">
      <img src="@/assets/icons/alarm.png" style="max-width:20%"/>
      <div class="error">{{ $t("message.subscription_expired") }}</div>
  </div>

  <div v-if="$common.qr.status==QR_STATUS_MAX_SCAN_REACHED" class="result-container">
      <img src="@/assets/icons/invalid.png" style="max-width:20%"/>
      <div class="error">{{ $t("message.max_scan_reached") }}</div>
  </div>

  <div v-if="$common.qr.status==QR_STATUS_FORBIDDEN" class="result-container">
    <img src="@/assets/icons/not-allowed.png" style="max-width:20%"/>
    <div class="error">{{ $t("message.not_allowed") }}</div>
  </div>

  <div v-if="$common.qr.status==QR_STATUS_INVALID_LOCATION" class="result-container">
    <img src="@/assets/icons/not-allowed.png" style="max-width:20%"/>
    <div class="error">{{ $t("message.geo_restricted") }}</div>
  </div>

  <div v-if="$common.qr.status==QR_STATUS_CLOSED" class="result-container">
    <img src="@/assets/icons/closed.png" style="max-width:20%"/>
    <div class="error">{{ $t("message.qr_closed") }}</div>
  </div>

  <div v-if="$common.qr.status==QR_STATUS_TO_SAVE" class="info-container">
    <div class="warning sentence">
      {{ $t("message.pleasesave") }}
    </div>
    <div style="margin-bottom:1rem">快捷版请点击下图箭头指示按钮保存</div>
    <img src="@/assets/images/quick_pleasesave.webp" style="width:80%"/>
    <div style="margin-top:1rem;margin-bottom:1rem">专业版请点击红色方框内的图标保存</div>
    <img src="@/assets/images/pleasesave.webp" style="width:80%"/>    
  </div>

</template>

<script>
import PwdPage from './components/pg/Pwd.vue';
import LoginPage from './components/pg/Login.vue';
import SelectLanguage from './components/pg/Selectlanguage.vue';
import ComponentContainer from './components/ComponentContainer.vue';
import QuickAlbum from './components/quick/QuickAlbum.vue';
import QuickText from './components/quick/QuickText.vue';
import QuickUrl from './components/quick/QuickUrl.vue';
import QuickFile from './components/quick/QuickFile.vue';
import QuickAudio from './components/quick/QuickAudio.vue';
import QuickVideo from './components/quick/QuickVideo.vue';
import axios from 'axios';

export default {
  name: 'MainApp',
  components: {
    QuickAlbum,
    QuickText,
    QuickUrl,
    QuickFile,
    QuickAudio,
    QuickVideo,
    ComponentContainer
  },
  data() {
    return {
      QR_STATUS_INVALID:0,
      QR_STATUS_LOADING:-1,
      QR_STATUS_VALID:1,
      QR_STATUS_PWD_REQUIRED:-5,
      QR_STATUS_NOT_STARTED:-6,
      QR_STATUS_ENDED:-7,
      QR_STATUS_FORBIDDEN:-8,
      QR_STATUS_TO_SAVE:-9,
      QR_STATUS_PLAN_EXPIRED:-10,
      QR_STATUS_MAX_SCAN_REACHED:-11,
      QR_STATUS_CLOSED:-12,
      QR_STATUS_INVALID_LOCATION:-13,
      TYPE_TXT:"1",
      TYPE_VCARD:"2",
      TYPE_URL:"3",
      TYPE_IMAGE:"21",
      TYPE_MP3:"22",
      TYPE_VIDEO:"23",
      TYPE_FILE:"24",
      TYPE_EMAIL:"4",
      TYPE_SMS:"5",
      TYPE_WIFI:"6",
      TYPE_CALL:"7",
      TYPE_APPSTORE:"8",
      TYPE_BITCOIN: "41",
      TYPE_PAYPAL: "42",
      TYPE_TWITTER:"52",
      TYPE_SOLUTION:"0",
      H_MARGIN_YES:1,
      POS_CENTER:1,
      sys_version:1, // 1 ---- 88 二维码， 2 ---- top qr
      SV_88:1,
      SV_TOP:2,
      qrjson:null
    }
  },
  methods:{
    initEntry(entrysettings){ // 仅仅用于入口页

        const rules=entrysettings.rules;

        for(var i=0; i<rules.length;i++){


            if(rules[i].type==1&&rules[i].value==this.$common.userid) // userid
              return rules[i].target;

            if(rules[i].type==2&&this.$common.roles.includes(rules[i].value)) // userole
              return rules[i].target;/**/

            if(rules[i].type==3) // daterange
            {

              const now = new Date();

              let fromatch=true;

              let tomatch=true;

              if(rules[i].value[0]!=null&&rules[i].value[0].trim().length>0){

                const from = new Date(rules[i].value[0]);

                if(now<from)
                  fromatch=false;

              }

              if(rules[i].value[1]!=null&&rules[i].value[1].trim().length>0){

                const to = new Date(rules[i].value[1]);

                if(now>to)
                  tomatch=false;

              }
              
              if(fromatch&&tomatch)
                return rules[i].target;

            }
            
            if(rules[i].type==4) // timerange
            {

              const now = new Date();

              const today= now.getFullYear()+'-'+now.getMonth()+'-'+now.getDay()+' ';

              let fromatch=true;

              let tomatch=true;

              if(rules[i].value[0]!=null&&rules[i].value[0].trim().length>0){
                                  
                const from = new Date(today+rules[i].value[0]);

                if(now<from)
                  fromatch=false;

              }

              if(rules[i].value[1]!=null&&rules[i].value[1].trim().length>0){

                const to = new Date(today+rules[i].value[1]);

                if(now>to)
                  tomatch=false;

              }
              
              if(fromatch&&tomatch)
                return rules[i].target;

            }

            if(rules[i].type==5) // device
            {

              if(rules[i].value==this.$common.device)
                return rules[i].target;
                
            }

            if(rules[i].type==6) // language
            {

              if(rules[i].value==this.$i18n.locale)
                return rules[i].target;
                
            }            
        }
      
        if(entrysettings.default)
          return entrysettings.default; 
        else
        {

          const qrjson=JSON.parse(this.$common.qr.qrjson);

          return qrjson.pages[0].key;  

        }
          

    },
    renderPg(pg){

          this.$common.qr.pgkey=pg;

          if(this.$common.qr.pgkey){

            const qrjson=JSON.parse(this.$common.qr.qrjson);

            for(var i=0; i<qrjson.pages.length;i++){

                if(this.$common.qr.pgkey==qrjson.pages[i].key)
                {

                    const settings=qrjson.pages[i].settings;

                    if(settings)
                    {

                      const pg_nav=settings.nav;

                      if(pg_nav&&pg_nav.title.trim()!=''&&!this.$common.trademark)
                        document.title=pg_nav.title

                      this.$common.app_style=this.generatePgStyle(settings);

                    }
                    else
                      this.$common.app_style={};

                    this.components=qrjson.pages[i].components;
                    
                    this.$forceUpdate();

                    break;

                }

            }

          }


    },
    generatePgStyle(settings){

      const bg=settings.bg;

      const bgStyle=this.$common.generateBgStyle(bg);

      const cssStyle=this.$common.cssStr2Json(settings.css);

      const style={...bgStyle, ...cssStyle};

      return style;

    },
    languageSettings(){ // TRUE --- 已确定  false --- 待确定

      var qrlanguage=this.$common.qrlanguage;

      if(qrlanguage){

          if(qrlanguage.mode=='2') // 手动
          {

            if(qrlanguage.value.length>1){

                const _this=this;

                this.$dialog.open(SelectLanguage, {
                                props: {
                                      style: {
                                          width: '100vw',
                                          height: '100vh',
                                      },
                                      modal: true,
                                      closable:false,
                                      showHeader:false,
                                      maximizable:true
                                },
                                data:{
                                  //message:this.$t('message.submit_require_login'),
                                  qrlanguage:qrlanguage
                                },
                                onClose() { // 执行下一步

                                  if(_this.$common.qr.status==_this.QR_STATUS_PWD_REQUIRED)
                                      _this.callbackPassword();
                                  else
                                      _this.callbackLogin();

                                }
                              }); 

                return false;

            }
            else
            {

              this.$i18n.locale=qrlanguage.value[0];

              return true;

            }
              
          }
          else
          {

            var b_locale_in_list=false;

            for(var i=0; i<this.$common.languages.length; i++){

              if(this.$i18n.locale==this.$common.languages[i].code)
              {

                  b_locale_in_list=true;

                  break;

              }
            }

            if(!b_locale_in_list)
              this.$i18n.locale=qrlanguage.value;

            return true;

          }
            
      }

      return true;

    },
    callbackLogin(){

      // 只有 type == solution 且行为与身份有关才需要 login

      const type=this.$common.qr.type;

      if(type==this.TYPE_SOLUTION&&this.sys_version!=this.SV_88){

        const _this=this;

        this.$dialog.open(LoginPage, {
                                props: {
                                      style: {
                                          width: '100vw',
                                          height: '100vh',
                                      },
                                      modal: true,
                                      closable:false,
                                      showHeader:false,
                                      maximizable:true
                                },
                                data:{
                                  
                                },
                                onClose() { // 执行下一步

                                  _this.callbackPage();

                                }
                              }); 

      }
      else
        this.callbackPage();


    },
    callbackPassword(){

      const _this=this;

      this.$dialog.open(PwdPage, {
                                props: {
                                      style: {
                                          width: '100vw',
                                          height: '100vh',
                                      },
                                      modal: true,
                                      closable:false,
                                      showHeader:false,
                                      maximizable:true
                                },
                                data:{
                                  
                                },
                                onClose() { // 执行下一步

                                  _this.callbackLogin();

                                }
                              }); 
                              
    },
    callbackPage(){

      const type=this.$common.qr.type;

      if(this.$common.qr.status==this.QR_STATUS_INVALID)
        return;

      if(type==this.TYPE_SOLUTION){

            if(this.$common.qr.pgkey&&this.$common.qr.pgkey.trim().length>0){

              this.renderPg(this.$common.qr.pgkey);

            }
            else
            {

              let qrjson;

              if (typeof this.$common.qr.qrjson==='string')
                  qrjson=JSON.parse(this.$common.qr.qrjson);
              else
                  qrjson=this.$common.qr.qrjson;

              const pg = this.initEntry(qrjson.entry_pg);

              this.$router.push({path:'/', query:{k:this.$common.qr.key, s:this.$common.qr.sk, p:pg},redirect:true});

            }

      }
      else
      {


            this.qrjson=JSON.parse(this.$common.qr.qrjson);

            this.playBgAudio();

            this.$forceUpdate();

            this.$root.$forceUpdate();

            if(type==this.TYPE_APPSTORE){

              if(this.$common.device==this.$common.DEVICE_ANDROID)

                window.location.href=this.qrjson.android;

              else if(this.$common.device==this.$common.DEVICE_IPAD)

                window.location.href=this.qrjson.ipad;

              else if(this.$common.device==this.$common.DEVICE_IOS)

                window.location.href=this.qrjson.iphone;

              else if(this.$common.device==this.$common.DEVICE_OTHER)

                window.location.href=this.qrjson.other;

            }

      }
    },
    loadGeoPage(){
  
      var k,s,p;
  
      if(this.$common.version==this.$common.E88){
  
        k=this.$route.params.k;
  
        s=this.$route.params.s;
  
        p=this.$route.params.p;
  
      }
      // end of 88 ewm version
      if(k==null)
      {
  
        const q=this.$route.query;
  
        k=q.k;
  
        s=q.s;
  
        p=q.p;
  
      }

      if(!k)
        this.$common.qr.status=this.QR_STATUS_VALID;
      else if(k=='pleasesave')
        this.$common.qr.status=this.QR_STATUS_TO_SAVE;
      else if(k!=this.$common.qr.key)
      {

          this.$common.qr.key=k;
  
          this.$common.qr.sk=s;

          this.checkGeo();

      }
      else
      {

          if(this.$common.qr.sk!=s)
          {

            this.$common.qr.sk=s;

            this.loadPage();

          }
          else if(this.$common.qr.pgkey!=p){

            this.$common.qr.pgkey=p;
  
            this.renderPg(p);

          }

      }

    },
    checkGeo() {

      const _this=this;

      axios.get(this.$common.HOST+'/qr/geoprotect.html?key='+this.$common.qr.key)
           .then(response=>{

              const geo_protect=response.data;

              if(geo_protect&&geo_protect.enable){

                  if(geo_protect.lng>=-180
                  &&geo_protect.lng<=180
                  &&geo_protect.lat>=-90
                  &&geo_protect.lat<=90
                  &&geo_protect.radius>0)
                  {

                    const options = {  
                      enableHighAccuracy: true,   
                      timeout: 5000,   
                      maximumAge: 1000   
                    }; 
                    
                    if(navigator.geolocation){  
                      navigator.geolocation.getCurrentPosition((res)=>{

                        const lng=res.longitude;

                        const lat=res.latitude;

                        const center_lng=geo_protect.lng;

                        const center_lat=geo_protect.lat;

                        const distance=_this.getDistance(lng, lat, center_lng, center_lat);
                
                        if(distance*1000<=geo_protect.radius){

                          _this.loadPage();

                        }
                        else
                        {

                          _this.$common.qr.status=_this.QR_STATUS_INVALID_LOCATION;


                        }
                        
                        
                      },
                      ()=>{

                        _this.$common.qr.status=_this.QR_STATUS_INVALID_LOCATION;

                        _this.$forceUpdate();

                      },options);   
                    }
                    else
                    {  

                      _this.$common.qr.status=_this.QR_STATUS_INVALID_LOCATION;

                    }  

                  }
                  else
                    _this.loadPage();
                

              }
              else
                _this.loadPage();              

           })
           .catch(()=>{

              _this.$common.qr.status=_this.QR_STATUS_VALID;

            }  
           )
    },
    getDistance(lat1, lon1, lat2, lon2) {

      const R = 6371; // 半径 of the earth in km 

      const dLat = this.deg2rad(lat2-lat1);  // deg2rad below 

      const dLon = this.deg2rad(lon2-lon1);  

      const a =   
        Math.sin(dLat/2) * Math.sin(dLat/2) +  
        Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *   
        Math.sin(dLon/2) * Math.sin(dLon/2)  
        ;  

      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 

      const d = R * c; // Distance in km  

      return d;  

    }, 
    deg2rad(deg) {

      return deg * (Math.PI/180) 

    },
    loadPage(){

          const k=this.$common.qr.key;
  
          const s=this.$common.qr.sk;

          axios
            .get(this.$common.HOST+'/qr/view.html?key='+k+'&sk='+(s==undefined?'':s))
            .then(response => {
  
                
  
                this.$common.qr.status=response.data.status;
  
                if(this.$common.qr.status==this.QR_STATUS_INVALID)
                {
  
                  this.$forceUpdate();
  
                  return;
                  
                }
  
                this.$common.qrlanguage = JSON.parse(response.data.qrlanguage);

                this.sys_version=Number(response.data.sys_version);
  
                this.$common.qr.qrid=response.data.qrcode.id;
  
                this.$common.qr.type=response.data.qrcode.type;

                this.$common.trademark=response.data.trademark;

                this.$common.qr.srid=response.data.srid;

                this.$common.qr.qrjson = response.data.qrcode.qrjson;                
  
                const bLng=this.languageSettings();
  
                if(!bLng) // 语言未确定
                  return; // languageSettings 里面会调用 selectlanguage
                
  
                if(this.$common.qr.status==this.QR_STATUS_VALID)
                {
  
                    if(this.$common.qr.type!=this.TYPE_SOLUTION)
                    {
  
                      const qrjson=JSON.parse(this.$common.qr.qrjson);
  
                      if(qrjson.bg)
                        this.$common.app_style=this.$common.generateBgStyle(qrjson.bg.visual);
  
                      this.$common.app_class=qrjson&&qrjson.horizontal==this.H_MARGIN_YES?'horizontal-margin':'';
  
                      this.$common.app_top=qrjson&&qrjson.position==this.POS_CENTER&&this.$common.qr.type!=this.TYPE_SOLUTION;
  
                    }
  
                    this.callbackLogin();
  
                }
                
                if(this.$common.qr.status==this.QR_STATUS_PWD_REQUIRED){
  
                  this.callbackPassword();
  
                }
  
            })
            .catch(() => {

                this.$toast.add({severity:'error', summary: this.TITLE, detail:this.$t('message.scan_error'), life: 3000});
  
            })
    },
    playBgAudio(){

      

    }
  },
  created(){

    const nav_lng=navigator.language;

    if(nav_lng.toLowerCase()=='zh-cn')
      this.$i18n.locale='hans';
    else if(nav_lng.toLowerCase().startsWith('zh'))
      this.$i18n.locale='hant';
    else
      this.$i18n.locale=nav_lng;


    if(this.$common.version==this.$common.E88){

      this.$common.HOST='https://ws.88erweima.top';

      document.title=this.$t("message.title_88E");

    }
    else
      document.title=this.$t("message.title_top_qr");


    this.$common.detectDevice();

    this.loadGeoPage();

    this.$watch(
      ()=>this.$route.params,
      () => {

        this.loadGeoPage();

      }
    )
 
  },
  mounted(){

  }
}
</script>

<style>
  .result-container{
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding:0 2rem;
  }
  .info-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height:80vh;
    width:100vw;
  }
  .warning{
    margin:0em 2em 5em 2em;
    text-align: center;
    color:#ef4444;
  }
  .error{
    color:#73000c;
    margin-top: 2rem;
  }

  /* loading css */
  .lds-roller {
    display: block;
    position: relative;
    width: 80px;
    height: 80px;
  }
  .lds-roller div {
    animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    transform-origin: 40px 40px;
  }
  .lds-roller div:after {
    content: " ";
    display: block;
    position: absolute;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #3b82f6;
    margin: -4px 0 0 -4px;
  }
  .lds-roller div:nth-child(1) {
    animation-delay: -0.036s;
  }
  .lds-roller div:nth-child(1):after {
    top: 63px;
    left: 63px;
  }
  .lds-roller div:nth-child(2) {
    animation-delay: -0.072s;
  }
  .lds-roller div:nth-child(2):after {
    top: 68px;
    left: 56px;
  }
  .lds-roller div:nth-child(3) {
    animation-delay: -0.108s;
  }
  .lds-roller div:nth-child(3):after {
    top: 71px;
    left: 48px;
  }
  .lds-roller div:nth-child(4) {
    animation-delay: -0.144s;
  }
  .lds-roller div:nth-child(4):after {
    top: 72px;
    left: 40px;
  }
  .lds-roller div:nth-child(5) {
    animation-delay: -0.18s;
  }
  .lds-roller div:nth-child(5):after {
    top: 71px;
    left: 32px;
  }
  .lds-roller div:nth-child(6) {
    animation-delay: -0.216s;
  }
  .lds-roller div:nth-child(6):after {
    top: 68px;
    left: 24px;
  }
  .lds-roller div:nth-child(7) {
    animation-delay: -0.252s;
  }
  .lds-roller div:nth-child(7):after {
    top: 63px;
    left: 17px;
  }
  .lds-roller div:nth-child(8) {
    animation-delay: -0.288s;
  }
  .lds-roller div:nth-child(8):after {
    top: 56px;
    left: 12px;
  }
  @keyframes lds-roller {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .p-inputtext{
    width:100% !important;
  }
  .row{
    margin-bottom:1rem !important;
  }
  .sentence{
    line-height: 1.5rem;
  }
  .p-dialog{
    max-height:100%;
  }
  .p-dialog-content{
    padding:0 !important
  }
</style>
